import React from 'react';
import btn from 'rawr/layout/btn';
import cn from 'classnames';

export default React.createClass({
    render() {
        const props = _.assign({
            type: 'button',
            'data-icon-before': this.props.buttonIconBefore,
            'data-icon-after': this.props.buttonIconAfter
        }, this.props);

        props.className = cn(
            btn(this.props.btn || {}),
            this.props.className
        );

        return <button {...props} />;
    }
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/rawr/layout/Button.jsx
 **/